<template>
	<v-row justify="center" class="pt-2" dense>
		<template v-for="(question) in questions2">
			<v-col :key="question.id" cols="12">
				<template v-if="question.questionType == 'switch'">
					<div class="subtitle-1">{{ question.description }}</div>
					<v-switch
						v-model="question.value"
						color="primary"
						:false-value="question.results[0].id"
						:true-value="question.results[1].id"
					>
						<template #prepend>
							<v-label>{{ question.results[0].description }}</v-label>
						</template>
						<template #append>
							<v-label>{{ question.results[1].description }}</v-label>
						</template>
					</v-switch>
				</template>

				<template v-else-if="question.questionType == 'radio'">
					<div class="subtitle-1">{{ question.description }}</div>
					<v-radio-group
						v-model="question.value"
						hide-details
						:rules="question.required ? [rules.required] : []"
						active-class="red--text"
					>
						<template v-for="answer in question.results">
							<v-radio :key="answer.id" color="primary" :label="answer.description" :value="answer.id"></v-radio>
						</template>
					</v-radio-group>
				</template>

				<template v-else-if="question.questionType == 'checkbox'">
					<div class="subtitle-1">{{ question.description }}</div>

					<template v-for="answer in question.results">
						<v-checkbox
							:key="answer.id"
							v-model="question.value"
							color="primary"
							:label="answer.description"
							:value="answer.id"
							hide-details
						></v-checkbox>
					</template>
				</template>

				<template v-else-if="question.questionType.indexOf('textfield') != -1">
					<div class="subtitle-1">{{ question.description }}</div>

					<template v-for="answer in question.results">
						<v-text-field
							:key="answer.id"
							v-model="answer.value"
							:rules="question.required ? [rules.required] : ''"
							class="pt-2"
							hide-details
							outlined
							:placeholder="answer.placeholder"
							:label="answer.description"
						></v-text-field>
					</template>
				</template>

				<template v-else-if="question.questionType.indexOf('file') != -1">
					<div class="subtitle-1">{{ question.description }}</div>
					<v-row dense>
						<template v-for="(answer, index) in question.results">
							<v-col :key="answer.id" cols="12" md="6" class="pt-1 pb-4">
								<span>{{ answer.description }}</span>
								<small v-if="index <= question.required-1">&nbsp;(required)</small>
								<app-button-file-uploader v-model="answer.file" :required="index <= question.required-1"></app-button-file-uploader>
							</v-col>
						</template>
					</v-row>
				</template>

				<template v-else>{{ question }}</template>
			</v-col>

			<template v-for="answer in question.results">
				<template v-if="answer.textfield">
					<v-col v-if="question.value == answer.id" :key="answer.id + '_'" cols="12">
						<v-text-field
							v-model="question.text"
							hide-details
							outlined
							:label="answer.textfield"
							:placeholder="answer.placeholder"
							:rules="[rules.required]"
						></v-text-field>
					</v-col>

					<v-col
						v-else-if="Array.isArray(question.value) && question.value.indexOf(answer.id) != -1"
						:key="answer.id + '_'"
						cols="12"
					>
						<v-text-field
							v-model="question.text"
							hide-details
							outlined
							:label="answer.textfield"
							:placeholder="answer.placeholder"
							:rules="[rules.required]"
						></v-text-field>
					</v-col>
				</template>
			</template>

			<v-col :key="question.id + '-'" cols="12">
				<div class="py-0">
					<v-divider v-if="sectioned"></v-divider>
				</div>
			</v-col>
		</template>
	</v-row>
</template>

<script>
export default {
	components: {
		"app-button-file-uploader": require("@/components/_general/AppButtonFileUploader")
			.default
	},
	mixins: [require("@/mixins/rules-mixin").default],
	props: {
		value: Array,
		questions: { type: Array, required: true },
		appointmentId: { type: [Number, String], required: true },
		docId: { type: [Number, String], required: true },
		relatedResult: { type: Number, default: 0 },
		sectioned: { type: Boolean, default: false }
	},
	data() {
		return {
			questions2: []
		};
	},
	computed: {
		questionsAndAnswers() {
			var questionsAndAnswers = [];

			this.questions2.map(question => {
				if (question.questionType == "textfield") {
					for (let answer of question.results) {
						let newQuestion = {
							appointmentId: this.appointmentId,
							docId: this.docId,
							result: answer.id,
							note: answer.value,
							relatedResult: this.relatedResult
							// duration: answer.duration //MAYBE NOT NEEDED?
						};

						questionsAndAnswers.push(newQuestion);
					}
				} else if (question.questionType == "checkbox") {
					let values = question.value || [];
					for (let answer of values) {
						let duration;
						let thisQuestion;
						try {
							thisQuestion = question.results.filter(
								item => item.id == answer
							)[0];
							duration = thisQuestion.duration || Infinity;
						} catch (error) {
							duration = Infinity;
						}

						var note = question.text || null;

						let newQuestion = {
							appointmentId: this.appointmentId,
							docId: this.docId,
							result: answer,
							note: note,
							relatedResult: this.relatedResult,
							duration: duration
						};

						questionsAndAnswers.push(newQuestion);
					}
				} else if (question.questionType == "file") {
					let values = question.results || [];
					for (let answer of values) {
						if (answer.file) {
							let newQuestion = {
								appointmentId: this.appointmentId,
								docId: this.docId,
								file: answer.file,
								result: answer.id,
								note: null,
								relatedResult: this.relatedResult
							};

							questionsAndAnswers.push(newQuestion);
						}
					}
				} else if (question.value) {
					let duration;
					let thisQuestion;
					try {
						thisQuestion = question.results.filter(
							item => item.id == question.value
						)[0];
						duration = thisQuestion.duration || Infinity;
					} catch (error) {
						duration = Infinity;
					}

					let newQuestion = {
						appointmentId: this.appointmentId,
						docId: this.docId,
						result: question.value,
						note: question.text || null,
						relatedResult: this.relatedResult,
						duration: duration
					};

					questionsAndAnswers.push(newQuestion);
				} else {
					console.log("Not added");
				}
			});

			return questionsAndAnswers;
		}
	},
	watch: {
		questionsAndAnswers(val) {
			this.$emit("input", val);
		}
	},
	mounted() {
		this.prepareQuestions();
	},
	methods: {
		prepareQuestions() {
			if (this.questions.length == 0) {
				setTimeout(() => {
					this.prepareQuestions();
				}, 500);
				return;
			}

			var questions = this.questions;

			for (var question of questions) {
				this.questionMapper(question);
				for (var answer of question.results) {
					this.answerMapper(answer, question.questionType);
				}
			}

			this.questions2 = questions;
		},

		questionMapper(question) {
			this.$set(question, "text", ""); // Maybe needed?

			if (question.questionType.indexOf("checkbox") != -1) {
				this.$set(question, "value", []);
			} else {
				this.$set(question, "value", null);
			}

			if (question.questionType == "switch") {
				question.value = question.results[0].id;
			}
		},
		answerMapper(answer, questionType) {
			var map = [
				{ title: "placeholder", regexp: /\[(.*)\]/ },
				{ title: "textfield", regexp: /<(.*)>/ }
			];

			var descriptionMap = [{ title: "duration", regexp: /\((.*)\)/ }];

			for (let mapper of map) {
				if (mapper.regexp.test(answer.answerType)) {
					let value = answer.answerType.match(mapper.regexp);
					answer.answerType = answer.answerType.replace(
						mapper.regexp,
						""
					);
					this.$set(answer, mapper.title, value[1]);
				}
			}

			for (let mapper of descriptionMap) {
				if (mapper.regexp.test(answer.description)) {
					let value = answer.description.match(mapper.regexp);
					answer.description = answer.description.replace(
						mapper.regexp,
						""
					);
					this.$set(answer, mapper.title, value[1]);
				}
			}

			if (questionType == "textfield") {
				this.$set(answer, "value", "");
			}

			if (questionType == "checkbox") {
				this.$set(answer, "value", "");
			}

			if (questionType == "file") {
				this.$set(answer, "value", null);
				this.$set(answer, "file", null);
			}
		}
	}
};
</script>

<style>
.v-input {
	margin-top: 0 !important;
	padding-bottom: 5px;
}

.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot,
.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
	margin-bottom: 0;
}
.v-input--checkbox,
.v-input--radio-group {
	margin-top: 0;
	margin-bottom: 0;
}
</style>
